// filepath: cryptobag-com/src/components/TrendingNow.jsx
import React from 'react';
import { icons } from '../assets/icons';

/**
 * TrendingNow Component
 * Shows the top 7 trending coins in a responsive, wrapping grid.
 */
const TrendingNow = ({ loading, trendingCoins, onCoinClick }) => {
  
  const TrendingSkeleton = () => (
    <div className="animate-pulse">
      <div className="h-5 bg-gray-700 rounded w-1/3 mb-4"></div>
      <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-7 gap-4">
        {Array(7).fill(0).map((_, i) => (
          <div key={i} className="flex-shrink-0 bg-gray-800/60 backdrop-blur-sm border border-gray-700/50 rounded-lg p-4">
            <div className="flex items-center space-x-3 mb-3">
              <div className="w-7 h-7 bg-gray-700 rounded-full"></div>
              <div className="h-4 bg-gray-700 rounded w-20"></div>
            </div>
            <div className="h-4 bg-gray-700 rounded w-16"></div>
          </div>
        ))}
      </div>
    </div>
  );

  if (loading || trendingCoins.length === 0) {
    return (
      <div className="mb-6">
        <TrendingSkeleton />
      </div>
    );
  }

  return (
    <div className="mb-6 animate-fadeIn">
      <h3 className="text-sm font-medium text-gray-400 mb-4 flex items-center">
        {icons.trending({ className: "w-5 h-5 mr-2 text-indigo-400" })}
        Trending Now
      </h3>
      <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-7 gap-4">
        {trendingCoins.map(({ item }) => (
          <div
            key={item.id}
            onClick={() => onCoinClick(item.id)}
            className="flex-shrink-0 bg-gray-800/60 backdrop-blur-sm border border-gray-700/50 rounded-lg shadow-xl p-4 cursor-pointer transition-all duration-300 hover:shadow-2xl hover:border-indigo-500/50"
          >
            <div className="flex items-center space-x-3 mb-3">
              <img src={item.small} alt={item.name} className="w-7 h-7 rounded-full" />
              {/* This div applies the fix for long names */}
              <div className="min-w-0"> 
                <div className="text-sm font-medium text-white truncate">{item.name}</div>
                <div className="text-xs text-gray-400 uppercase">{item.symbol}</div>
              </div>
            </div>
            <div className="text-sm text-gray-300">Rank #{item.market_cap_rank}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TrendingNow;